export interface ReadyRiftCellsMaterial {
  id: string;
  packageId: string;
  kind: 'LONG FORM' | 'SHORT';
  title: string;
  stage: 'READY' | 'RENDERING';
  updated?: string;
  videoJobId?: string;
}

/** Only surface Shorts that have their own render job; ideas are not videos. */
export function readyRiftCellsMaterials(packages: any[], jobs: any[]): ReadyRiftCellsMaterial[] {
  const ready = new Set(['READY', 'RENDERING']);
  return packages.flatMap((row) => {
    let metadata: any = {};
    try { metadata = typeof row.metadata === 'string' ? JSON.parse(row.metadata) : row.metadata ?? {}; } catch { metadata = {}; }
    const renderedShorts = jobs.filter((job) => job.package_id === row.id && job.job_type === 'ENGINE_SHORT' && ready.has(String(job.status)));
    const shortMaterials: ReadyRiftCellsMaterial[] = [];
    for (const job of renderedShorts) {
      let payload: any = {};
      try { payload = typeof job.payload === 'string' ? JSON.parse(job.payload) : job.payload ?? {}; } catch { payload = {}; }
      if (!payload.renderJobId || !payload.short) continue;
      shortMaterials.push({
        id: `${row.id}-short-${job.id}`, packageId: row.id, kind: 'SHORT',
        title: payload.short.title ?? payload.short.hook ?? 'RiftCells Short', stage: job.status,
        updated: job.updated_at ?? row.updated_at, videoJobId: payload.renderJobId,
      });
    }
    const standaloneShort = shortMaterials.find((material) => material.videoJobId === metadata.render?.jobId);
    const materials: ReadyRiftCellsMaterial[] = [];
    if (standaloneShort) return [standaloneShort, ...shortMaterials.filter((material) => material !== standaloneShort)];
    if (ready.has(String(row.stage))) materials.push({
      id: `${row.id}-long`, packageId: row.id, kind: 'LONG FORM',
      title: metadata.primaryTitle ?? 'RiftCells long-form package', stage: row.stage,
      updated: row.updated_at, videoJobId: metadata.render?.jobId,
    });
    materials.push(...shortMaterials);
    return materials;
  });
}
